<template>
<svg xmlns="http://www.w3.org/2000/svg" :fill="useCurrentColor ? 'currentColor' : '#000'" viewBox="0 0 48 48" :class="[`${prefix}-icon`, `${prefix}-icon-Toggle`]" width="1em" height="1em" v-bind="$attrs"><defs><clipPath id="svg_bec7e4d621__a"><rect width="48" height="48" rx="0"/></clipPath></defs><g clip-path="url(#svg_bec7e4d621__a)"><path d="M39.81,28.0448L8.19,28.0448C7.256277,28.0448,6.5,28.8248,6.5,29.7877C6.5,30.1537,6.60985,30.4936,6.795751,30.7724C6.876026,30.9685,6.998551,31.1515,7.150652,31.3127L14.59935,38.9902C14.9289,39.3301,15.35985,39.5,15.79503,39.5C16.2302,39.5,16.6612,39.3301,16.9907,38.9902C17.6498,38.310500000000005,17.6498,37.2081,16.9907,36.524L12.14039,31.5306L39.8058,31.5306C40.7395,31.5306,41.4958,30.7507,41.4958,29.7877C41.4958,28.8248,40.7437,28.0448,39.81,28.0448ZM8.19,19.9578L39.81,19.9578C40.7437,19.9578,41.5,19.177799999999998,41.5,18.21489C41.5,17.84888,41.3902,17.50902,41.2043,17.230150000000002C41.1451,17.08636,41.0606,16.946930000000002,40.9592,16.81622L34.8667,9.138761C34.2752,8.393673,33.210499999999996,8.284742,32.488,8.894755C31.7656,9.50477,31.6599,10.60279,32.251400000000004,11.34788L36.3201,16.471989999999998L8.19,16.471989999999998C7.256277,16.471989999999998,6.5,17.251939999999998,6.5,18.21489C6.5,19.177799999999998,7.256277,19.9578,8.19,19.9578Z"/></g></svg>
</template>
<script>

export default {
  name: 'IconToggle',
  props: {
    prefix: {
        type: String,
        default: 'cmstopgpt',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
